import { AUTH, LOGOUT } from "../constants/actionTypes";
import * as api from "../api/index.js";


export const signin = (values, setLoading, navigate, toast) => async (dispatch) => {
    try {
        const { data } = await api.signIn(values);

        // ✅ Check if user is admin
        if (data.isAdmin === 1) {
            localStorage.setItem("profile", JSON.stringify(data));
            dispatch({ type: AUTH, data });
            setLoading(false);
            toast.success("Admin login successful");

            setTimeout(() => {
                navigate('/posts'); // or your admin route
            }, 2000);
        } else {
            setLoading(false);
            toast.error("Please log in with your admin account.");
        }

    } catch (error) {
        setLoading(false);
        toast.error(error.response?.data || 'ERR_CONNECTION_REFUSED');
        console.log(error);
    }
}


export const signup = (payload, setLoading, navigate, toast) => async (dispatch) => {
    try {
        const { data } = await api.signUp(payload);
        dispatch({ type: AUTH, data });
        setLoading(false)
        toast.success("Form Submitted Successfully");
        setTimeout(() => {
            navigate('/');
        }, 2000);
    } catch (error) {
        setLoading(false)
        console.log(error)
        toast.error(error.response.data || 'ERR_CONNECTION_REFUSED');
    }
}

export const logout = (navigate, toast) => async (dispatch) => {
    try {
        await api.logout();
        dispatch({ type: LOGOUT, data: null });
        // toast.success("Logged out successfully");
        setTimeout(() => {
            navigate('/');
        }, 1000);
    } catch (error) {
        console.log(error);
        toast.error(error.response.data || 'ERR_CONNECTION_REFUSED');
    }
}